<template>
    <b-card
    header-bg-variant="primary"
    header-class="py-2 px-3 text-white"
    body-class="p-3"
    footer-class="py-2 px-3"
    class="mx-0">
    <template #header>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shield-plus" viewBox="0 0 16 16"><path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56"/><path d="M8 4.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5a.5.5 0 0 1 .5-.5"/></svg>
        Insurance
        <a href="javascript:void(0)" @click="$emit('remove-product-application', product_application.pcom_id)" class="position-absolute cursor-pointer" style="right: -14px; top: -7px;" v-if="is_editable">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="20" height="20" viewBox="0 0 512 512">
                <circle fill="#DF3030" cx="256" cy="256" r="256" />
                <g fill="#fff" transform="translate(148, 116) scale(0.55)">
                    <path fill="#fff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/>
                </g>
            </svg>
        </a>
    </template>

    <!--Card Body -->
    <div class="my-2">
        <p class="text-xs text-muted">Insurance Type.</p>
        <p class="font-weight-600">
            <span v-if="product_application.pcom_product_detail.pcp_project_json.prod_ins_type">{{ product_application.pcom_product_detail.pcp_project_json.prod_ins_type.replace('_', ' ') }}</span>
            <span v-else>N/A</span>
        </p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Package</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_json.prod_ins_package }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Company</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_json.prod_ins_company }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Premium p.a</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_project_json.prod_ins_premium_pa | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Premium p.m</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_project_json.prod_ins_premium_pm | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Premium Cover</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_project_json.prod_ins_premium_cover | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Paid By</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_json.prod_ins_paid_by }}</p>
    </div>
</b-card>
</template>
<script>

export default {
    props:['product_application', 'is_editable']
}
</script>